import React, { useState, useEffect } from 'react';
import { Toaster } from 'react-hot-toast';
import Navbar from './Navbar';
import HeroContent from './HeroContent';
import PopupForm from './PopupForm';

const HomeSection = () => {
    const [showPopup, setShowPopup] = useState(false);

    // Show popup on scroll (currently commented out in original)
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 200) {
                setShowPopup(true);
                // Uncomment to show popup only once
                // window.removeEventListener('scroll', handleScroll);
            }
        };
        // Uncomment to enable scroll popup
        // window.addEventListener('scroll', handleScroll);
        // return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const handleJoinWaitlist = () => setShowPopup(true);
    const handleClosePopup = () => setShowPopup(false);

    return (
        <>
            <Toaster />
            <Navbar />
            <HeroContent onJoinWaitlist={handleJoinWaitlist} />
            <PopupForm isVisible={showPopup} onClose={handleClosePopup} />
        </>
    );
};

export default HomeSection;
